module.exports = __webpack_public_path__ + "img/y14.18ca6d14.jpg";